export const STAR_ICON_SIZE_SMALL = 12;
export const STAR_ICON_SIZE_MEDIUM = 16;
export const STAR_ICON_SIZE_LARGE = 18;
